module.exports = __webpack_public_path__ + "static/media/background3.6109238d.jpg";